<template>
    <div class="escalations-step">
        <div class="escalations-step__table-wrapper">
            <table id="escalations" class="escalations-step__table">
                <thead>
                    <tr>
                        <th class="escalations-step__header escalations-step__header--year">Year</th>
                        <th
                            v-for="month in expenseMonths"
                            :key="month"
                            class="escalations-step__header escalations-step__header--month"
                        >
                            {{ month }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(row, year) in expense.timeline"
                        :key="year"
                        class="escalations-step__row"
                    >
                        <td class="escalations-step__cell escalations-step__cell--year">
                            {{ year }}
                        </td>
                        <td
                            v-for="(month, monthNumber) in row.months"
                            :key="monthNumber"
                            class="escalations-step__cell escalations-step__cell--input"
                        >
                            <input
                                type="text"
                                class="escalations-step__input"
                                :data-year="year"
                                :data-month="monthNumber"
                                @input="handleInput"
                                @blur="handleBlur"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EscalationsStep',

    props: {
        expense: {
            type: Object,
            required: true
        },
        expenseMonths: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        handleInput(event) {
            const year = parseInt(event.target.dataset.year);
            const month = parseInt(event.target.dataset.month);
            const value = event.target.value;

            this.$emit('set-escalation', { year, month, value });
        },

        handleBlur(event) {
            this.$emit('set-previous-input', event.target);
        }
    }
};
</script>
